export default function PHP_strip_tags() {
  return (
    <div>
      <h1>PHP_strip_tags</h1>
    </div>
  );
}
